module.exports = __webpack_public_path__ + "img/sp-logo.cd391db0.png";